export interface ChatHistoryItem {
  id: string;
  title: string;
  /** Last activity, as epoch ms. Drives the date grouping. */
  updatedAt: number;
  pinned?: boolean;
  archived?: boolean;
}

export interface ChatHistoryGroup {
  label: string;
  items: ChatHistoryItem[];
}

const DAY = 24 * 60 * 60 * 1000;

const startOfDay = (time: number) => {
  const date = new Date(time);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

/**
 * Pinned first, then Today / Yesterday / Previous 7 days / Older, newest
 * first within each. Archived items are left out; the caller lists them
 * separately. Empty groups are dropped.
 */
export const groupChatHistory = (
  items: readonly ChatHistoryItem[],
  now = Date.now()
): ChatHistoryGroup[] => {
  const today = startOfDay(now);
  const buckets: ChatHistoryGroup[] = [
    { label: 'Pinned', items: [] },
    { label: 'Today', items: [] },
    { label: 'Yesterday', items: [] },
    { label: 'Previous 7 days', items: [] },
    { label: 'Older', items: [] }
  ];

  [...items]
    .filter((item) => !item.archived)
    .sort((a, b) => b.updatedAt - a.updatedAt)
    .forEach((item) => {
      const index = item.pinned
        ? 0
        : item.updatedAt >= today
          ? 1
          : item.updatedAt >= today - DAY
            ? 2
            : item.updatedAt >= today - 7 * DAY
              ? 3
              : 4;
      buckets[index].items.push(item);
    });

  return buckets.filter((group) => group.items.length > 0);
};
